import React, { useEffect, useState, useCallback, useMemo } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";

import { Link, useParams } from "react-router-dom";
import config from "../../../../config/config";
import Loader from "../../../../components/Loader/Loader";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import Select from "react-select";
import { checkUserPermission } from "../../../../common/UserPermission";

const ItemNotCountedAndInStock = (props) => {
  const token = localStorage.getItem("Token");
  const [loading, setLoading] = useState(false);
  const paramObject = useParams();
  const [data, setData] = useState();

  useEffect(() => {
    axios
      .get(
        `${config.itemsBaseUrl}/items/itemnotcountedandinstocklisting?inventorycountid=${paramObject.id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res ==> ", res.data.ResponseData);
        setData(res.data.ResponseData);
      })
      .catch((err) => {
        console.log("err ==>", err);
      });
  }, []);

  // Dropdown Styles
  const selectStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
    }), // dropdown input css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
      // position: "absolute",
      background: "#f8f8f8",
      width: "100%",
    }), // dropdown menu css
  };

  // Table Data
  const columns = [
    {
      name: "Item Name",
      selector: (row) => row.ItemName,
      width: "10%",
      sortable: true,
    },
    {
      name: "Category Full Path",
      selector: (row) => row.CatergoryFullPath,
      sortable: true,
      width: "25%",
    },
    {
      name: "Item Number",
      selector: (row) => row.ItemNumber,
      sortable: true,
      width: "10%",
    },
    {
      name: "Product Id",
      selector: (row) => row.ProductId,
      sortable: true,
      width: "10%",
    },
    checkUserPermission('show-cost-price') &&(
      {
        name: "Cost Price",
        selector: (row) => parseFloat(row.CostPrice),
        sortable: true,
        width: "10%",
      }),
    {
      name: "Unit Price",
      selector: (row) => parseFloat(row.UnitPrice),
      sortable: true,
      width: "10%",
    },
    {
      name: "Actual On Hand",
      selector: (row) => parseFloat(row.ItemActualOnHand),
      sortable: true,
      width: "17%",
    },
  ];

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="page-title">
              <h3>New Count Inventory</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/items">Items</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/item-count-invetory">Count Inventory</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to={`/new-inventory-count/${paramObject.id}`}>
                    New Inventory Count
                  </Link>
                </li>
                <li className="breadcrumb-item active">
                  Item Not Counted & In Stock
                </li>
              </ul>
            </div>
          </div>

          <div className="card">
            <div className="card-body">
              <div className="card-body">
                <div className="d-flex flex-row-reverse mb-3">
                  <div className="p-2">
                    <Link
                      className="btn btn-sm btn-info"
                      to={`/new-inventory-count/${paramObject.id}`}
                    >{`<< Back`}</Link>
                  </div>
                  {/* <div className="p-2">
                    <Link className="btn  btn-sm btn-info">Print</Link>
                  </div> */}
                </div>
                {/* <div className="col-md-12 mb-4">
                  <Select
                    // onChange={(event) => {
                    //   handleDropDown(event, "TaxGroup");
                    // }}
                    // value={taxGroupOptions.find(
                    //   (option) => option?.value == selectedTaxGroup
                    // )}
                    // options={taxGroupOptions}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    styles={selectStyles}
                    id="AllCategories"
                    name="AllCategories"
                  />
                </div> */}
                <div className="table-responsive">
                  <DataTable
                    title="Item Not Counted And In Stock"
                    columns={columns}
                    data={data}
                    // progressPending={loading}
                    pagination
                    paginationServer
                    // paginationTotalRows={totalRows}
                    // paginationDefaultPage={currentPage}
                    // onChangeRowsPerPage={(e) => {
                    //   handlePerRowsChange(1, e);
                    // }}
                    // onChangePage={handlePageChange}
                    highlightOnHover
                    striped
                    responsive
                    paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                    fixedHeader
                    // fixedHeaderScrollHeight="70vh"
                    persistTableHead
                    sortServer
                    // onSort={handleSort}
                    selectableRows
                    // onSelectedRowsChange={e => { handleSelectedRowsChange(e); }}
                    // contextActions={contextActions}
                    // onSelectedRowsChange={handleRowSelected}
                    // clearSelectedRows={toggleCleared}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ItemNotCountedAndInStock;
